import React, { useState, useEffect } from 'react'
import { useAuth } from '../context/AuthContext'
import {
  updateProfile,
  changePassword,
  changeEmail,
  uploadProfileImage,
} from '../api/account'
import Nav from '../components/Nav'
import Footer from '../components/Footer'

export default function ProfilePage() {
  const { user, setUser, logout } = useAuth()
  const [formData, setFormData] = useState({
    username: user?.username || '',
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    email: user?.email || '',
    phoneNumber: user?.phoneNumber || '',
  })
  const [photoPreview, setPhotoPreview] = useState(user?.profileImageUrl || null)
  const [newEmail, setNewEmail] = useState('')
  const [password, setPassword] = useState('')
  const [photoFile, setPhotoFile] = useState(null)
  const [newPassword, setNewPassword] = useState('')
  const [currentPassword, setCurrentPassword] = useState('')
  const [loading, setLoading] = useState(false)

  // Préremplir les données
  useEffect(() => {
    if (user) {
      setFormData({
        username: user.username || '',
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        email: user.email || '',
        phoneNumber: user.phoneNumber || '',
      })
      setPhotoPreview(user.profileImageUrl || null)
    }
  }, [user])

  const handleChange = (k, v) => setFormData({ ...formData, [k]: v })

  const handlePhotoChange = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    setPhotoFile(file)
    setPhotoPreview(URL.createObjectURL(file))
    try {
      const res = await uploadProfileImage(file)
      const url = typeof res === 'string' ? res : (res?.url || res?.profileImageUrl || null)

      if (url) {
        updateAvatar(url)

        setUser((u)=> ({ ...(u||{}), profileImageUrl: url }))
      }
      alert('Photo mise à jour ✅')
    } catch (err) {
      console.error(err)
      alert('Erreur lors du téléchargement de la photo')
    }
  }

  // Sauvegarde profil
  const handleSubmit  = async (e) => {
    e.preventDefault()
    try {
        const payload = {
            username:    formData.username?.trim()    || user?.username || user?.userName || '',
            firstName:   formData.firstName?.trim()   || '',
            lastName:    formData.lastName?.trim()    || '',
            email:       formData.email?.trim()       || '',
            phoneNumber: formData.phoneNumber?.trim() || '',
            profileImageUrl: user?.profileImageUrl ?? null,
        }
      const updated = await updateProfile(payload) // PUT /api/account/profile/update
        const nextUser = updated && typeof updated === 'object' ? updated : {
        ...(user || {}),
        ...payload,
        }

        setUser(nextUser)
        localStorage.setItem('user', JSON.stringify(nextUser))
        alert('Profil mis à jour ✅')
    } catch (err) {
        console.error(err)
        alert('Erreur de mise à jour du profil')
    }
  }

  // Changer mot de passe
  const handlePasswordChange = async (e) => {
    e.preventDefault()
    try {
      await changePassword(currentPassword, newPassword)
      alert('Mot de passe changé ✅')
      setCurrentPassword('')
      setNewPassword('')
    } catch {
      alert('Erreur : mot de passe actuel invalide')
    }
  }

  // Changer e-mail
  const handleEmailChange = async (e) => {
    e.preventDefault()
    try {
      await changeEmail(newEmail, password)
      alert('E-mail mis à jour ✅')
    } catch {
      alert('Erreur lors du changement d’email')
    }
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Nav />

      <main className="flex-1 container mx-auto px-4 py-10">
        <h1 className="text-3xl font-extrabold text-blue-900 mb-8">
          Mon profil
        </h1>

        <div className="bg-white shadow-md rounded-2xl p-8 max-w-3xl mx-auto">
          {/* PHOTO */}
          <div className="flex flex-col items-center gap-4 mb-8">
            <div className="relative">
              <img
                src={
                  photoPreview ||
                  'https://www.svgrepo.com/show/382106/male-avatar-boy-face-man-user-5.svg'
                }
                alt="avatar"
                className="w-28 h-28 rounded-full object-cover border border-blue-100"
              />
              <label className="absolute bottom-0 right-0 bg-blue-600 text-white text-sm px-2 py-1 rounded-md cursor-pointer hover:bg-blue-700">
                📷
                <input
                  type="file"
                  accept="image/*"
                  onChange={handlePhotoChange}
                  className="hidden"
                />
              </label>
            </div>
            <h2 className="text-2xl font-semibold">
              {formData.firstName} {formData.lastName}
            </h2>
            <p className="text-gray-500">{formData.email}</p>
          </div>

          {/* --- INFOS PERSONNELLES --- */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <Field label="Nom d'utilisateur" value={formData.username} onChange={(v) => handleChange('username', v)} />
              <Field label="Prénom" value={formData.firstName} onChange={(v) => handleChange('firstName', v)} />
              <Field label="Nom" value={formData.lastName} onChange={(v) => handleChange('lastName', v)} />
              <Field label="Téléphone" value={formData.phoneNumber} onChange={(v) => handleChange('phoneNumber', v)} />
            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                disabled={loading}
                className="px-5 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50"
              >
                {loading ? 'Enregistrement...' : 'Enregistrer'}
              </button>
            </div>
          </form>

          <hr className="my-8" />

          {/* --- EMAIL --- */}
          <h3 className="text-lg font-semibold mb-2">Changer mon e-mail</h3>
          <form onSubmit={handleEmailChange} className="grid md:grid-cols-2 gap-4 mb-8">
            <Field label="Nouvel e-mail" value={newEmail} onChange={setNewEmail} />
            <Field label="Mot de passe actuel" type="password" value={password} onChange={setPassword} />
            <button
              type="submit"
              className="col-span-2 bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700"
            >
              Mettre à jour l’e-mail
            </button>
          </form>

          {/* --- Password --- */}
          <h3 className="text-lg font-semibold mb-2">Changer le mot de passe</h3>
          <form onSubmit={handlePasswordChange} className="grid md:grid-cols-2 gap-4">
            <Field label="Mot de passe actuel" type="password" value={currentPassword} onChange={setCurrentPassword} />
            <Field label="Nouveau mot de passe" type="password" value={newPassword} onChange={setNewPassword} />
            <button
              type="submit"
              className="col-span-2 bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700"
            >
              Mettre à jour le mot de passe
            </button>
          </form>

          {/* --- DECONNEXION --- */}
          <div className="text-center mt-10">
            <button
              onClick={logout}
              className="px-6 py-2 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700"
            >
              Se déconnecter
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

function Field({ label, value, onChange, type = 'text' }) {
  return (
    <div>
      <label className="block font-semibold text-gray-700 mb-1">{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400"
      />
    </div>
  )
}
